<template>
    <div class="contract">
        <div class="searchPart">
            <div class="toolRight">
                <el-button type="primary" size="small" @click="toDialog('add')"><i class="el-icon-circle-plus-outline"></i>添加</el-button>
            </div>
        </div>
        <div class="contractTable">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                class="tableContent"
            >
                <el-table-column
                    prop="shotCardNo"
                    label="卡号"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="bankName"
                    label="银行名称"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="bankCardTypeCn"
                    label="银行卡类型"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
<!--                        <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>-->
                        <el-button type="text" size="small" @click="remove(scope.row.uuid)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>
        </div>

        <!--添加/编辑签章弹出框-->
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            v-loading="loading"
            width="800px">
            <div class="dialogBoxClass">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="银行卡号" prop="bankCardNo">
                        <el-input v-model="form.bankCardNo" placeholder="请输入银行卡号" @change="searchBankCarBinInfo"></el-input>
                    </el-form-item>
                    <el-form-item label="银行名称" prop="bankName">
                        <el-input v-model="form.bankName" placeholder="请输入银行名称"></el-input>
                    </el-form-item>
                    <el-form-item label="银行卡类型" prop="bankCardType">
<!--                        <el-input v-model="form.bankCardType" placeholder="请输入银行卡类型" readonly></el-input>-->
                        <el-select v-model="form.bankCardType" clearable placeholder="请输入银行卡类型">
                            <el-option label="借记卡" value="DEBIT_CARD"> </el-option>
                            <el-option label="对公账号" value="ENTERPRISE_ACCOUNT"> </el-option>
                            <el-option label="单位结算卡" value="UNIT_SETTLEMENT_CARD"> </el-option>
                        </el-select>
                    </el-form-item>
                    <input type="hidden" v-model="form.bankCode"></input>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="submitForm">提交</el-button>
                        <el-button @click="dialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import {
    deleteBankCardInfo,
    getBankCardInfo,
    getBankCardInfoList,
    saveBankCardInfo,
    searchBankCarBinInfo,
    updateBankCardInfo
} from "../../utils/interface";

export default {
    name: "contract",
    data() {
        return {
            name: "",
            total: 0,
            current: 0,
            pageSize: 10,
            type: '',
            tableData: [],
            title: '',
            loading: false,
            form: {
                uuid:'',
                bankCardNo:'',
                bankName: '',
                bankCode: '',
                bankCardType: '',
            },
            rules: {
                bankCardNo: [{required: true, message: '请输入银行卡号',trigger: 'blur'}],
                bankName: [{required: true, message: '请输入银行名称',trigger: 'blur'}],
                bankCardType: [{required: true, message: '请选择银行卡类型',trigger: 'blur'}],
            },
            dialogVisible: false
        };
    },
    created() {
        this.search();
    },
    methods: {
        searchBankCarBinInfo(value) {
            searchBankCarBinInfo(value).then((res) => {
                if (res.success) {
                    const bankCardInfo = res.data;
                    this.form.bankName = bankCardInfo.bankName;
                    this.form.bankCode = bankCardInfo.bankCode;
                    this.form.bankCardType = bankCardInfo.bankCardType;
                    this.$refs.ruleForm.validate();
                }
            });
        },

        search() {
            let params = {
                current: this.current,
                pageSize: this.pageSize
            };
            getBankCardInfoList(params).then((res) => {
                this.current = res.current;
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        reset() {
            this.current = 1;
            this.search();
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.search();
        },
        // 点击打开添加/编辑签章弹出框
        toDialog(type,uuid){
            this.type = type
            this.dialogVisible = true
            this.form = {
                bankCardNo:'',
                bankName: '',
                bankCode: '',
                bankCardType: '',
            }

            if(type === 'add'){
                this.title = '添加银行卡'
            } else {
                this.title = '编辑银行卡'
                getBankCardInfo(uuid).then((res) => {
                    if (res.success) {
                        this.form = res.data;
                    }
                });
            }
        },

        remove(uuid){
            this.$confirm('确定要删除该银行卡吗' + '?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteBankCardInfo(uuid).then((res) => {
                    if (res.success) {
                        this.$message.success("删除成功");
                        this.search()
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });

        },

        submitForm(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true
                    if(this.type === 'edit') {
                        updateBankCardInfo(this.form,this.form.uuid).then((res) => {
                            if (res.success) {
                                this.$message.success("编辑成功");
                                this.dialogVisible = false;
                                this.search()
                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false
                        });
                    }else{
                        saveBankCardInfo(this.form).then((res) => {
                            if (res.success) {
                                this.$message.success("保存成功");
                                this.dialogVisible = false;
                                this.search()
                            } else {
                                this.$message.error(res.message);
                            }
                            this.loading = false
                        });
                    }
                    this.type = ''
                }else {
                    this.dialogVisible = true;
                    this.loading = false
                    // return false;
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.searchPart {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    /deep/ .el-input {
        width: initial;
        margin-bottom: 22px;
        margin-right: 30px;
    }

    /deep/ .el-input__inner {
        width: 242px;
        height: 35px;
        min-height: 35px;
        font-size: 12px;
        color: #999999;
        background-color: #f2f4f7;
        border: 1px solid #f2f4f7;
        border-radius: 5px;

        &:hover,
        &:focus {
            background-color: #fff;
            border: 1px solid #108ee9;
        }
    }

    /deep/ .el-input__prefix {
        top: -3px;
    }

    /deep/ .el-input__suffix {
        top: 2px;
    }

    /deep/ .el-button {
        display: block;
        line-height: 35px;
        padding: 0;
        height: 35px;
    }

    .searchBtn {
        width: 82px;
        background: #3d7fff;
        border: none;
        border-radius: 15px;
        font-size: 14px;
        color: #ffffff;
        margin-bottom: 22px;
    }

    .resetBtn {
        color: #333333;
        margin-bottom: 22px;
    }
}

.contract {
    padding: 20px;
}

.contractTable {
    .tableContent {
        min-height: 650px;
    }
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

/deep/ .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
}

.avatar-uploader .el-upload {
    border: 1px dashed black;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px solid #ddd;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

/deep/ .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
}

.avatar-uploader .el-upload {
    border: 1px dashed black;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px solid #ddd;
}

.toolRight{
    button{
        width: 83px;
        height: 30px;
        background: rgba(21, 126, 251, 1);
        border: none;
        border-radius: 15px;
        font-size: 13px;
        color: #fff;
        i{
            padding-right: 5px;
        }
        &:hover{
            background: #61a2f0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/balance/bankCardManage.vue